import { map } from 'rxjs';
import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, CanActivate, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);

  canActivate() {
    // Prerendering has no signed-in user to check; the browser re-runs this.
    if (!isPlatformBrowser(this.platformId)) return true;

    return this.authService.refreshPermissions().pipe(map(verified => {
      if (verified && this.authService.getCurrentUser()?.role === 'super_admin') return true;
      return this.router.parseUrl(verified ? this.authService.firstAllowedUrl() : '/admin/no-access');
    }));
  }
}
